import { Platform } from '@app/classes';
import { FeatureFlag } from '@app/enums';
import { StandardReports } from '../interfaces/standard-reports.interface';

export const STANDARD_REPORTS: StandardReports[] = [
    {
        name: 'reporting.reports.trainingReport.title',
        description: 'reporting.reports.trainingReport.description',
        routerLink: 'training-report',
    },
    {
        name: 'reporting.reports.payrollDigest.title',
        description: 'reporting.reports.payrollDigest.description',
        routerLink: 'payroll-digest',
    },
    {
        name: 'reporting.reports.benefitsDigest.title',
        description: 'reporting.reports.benefitsDigest.description',
        routerLink: 'benefits-digest',
    },
    {
        name: 'reporting.reports.timeToFill.title',
        description: 'reporting.reports.timeToFill.description',
        routerLink: 'time-to-fill-report',
        requiredModule: Platform.modules.recruiting,
    },
    {
        name: 'reporting.reports.additionsAndTerminations.title',
        description: 'reporting.reports.additionsAndTerminations.description',
        routerLink: 'additions-and-terminations',
        legacySlug: 'additions',
        chartType: 'bar',
        showLegend: true,
        isStacked: false,
        isDateBased: true,
        showCurrency: false,
        detailData: true,
    },
    {
        name: 'reporting.reports.ageProfile.title',
        description: 'reporting.reports.ageProfile.description',
        routerLink: 'age-profile',
        legacySlug: 'age',
        chartType: 'bar',
        showLegend: false,
        isStacked: false,
        isDateBased: false,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.departmentProfile.title',
        description: 'reporting.reports.departmentProfile.description',
        routerLink: 'department-profile',
        legacySlug: 'department',
        chartType: 'pie',
        showLegend: true,
        isStacked: false,
        isDateBased: false,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.legalSexProfile.title',
        description: 'reporting.reports.legalSexProfile.description',
        routerLink: 'legal-sex-profile',
        legacySlug: 'legal-sex',
        chartType: 'pie',
        showLegend: true,
        isStacked: false,
        isDateBased: false,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.headcountHistory.title',
        description: 'reporting.reports.headcountHistory.description',
        routerLink: 'headcount-by-department',
        legacySlug: 'headcount',
        chartType: 'line',
        showLegend: true,
        isStacked: true,
        isDateBased: true,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.salaryProfile.title',
        description: 'reporting.reports.salaryProfile.description',
        routerLink: 'salary-profile',
        legacySlug: 'salary',
        chartType: 'pie',
        showLegend: true,
        isStacked: false,
        isDateBased: false,
        showCurrency: true,
    },
    {
        name: 'reporting.reports.seniorityProfile.title',
        description: 'reporting.reports.seniorityProfile.description',
        routerLink: 'seniority-profile',
        legacySlug: 'seniority',
        chartType: 'bar',
        showLegend: false,
        isStacked: false,
        isDateBased: false,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.timeOffBalances.title',
        description: 'reporting.reports.timeOffBalances.description',
        routerLink: 'employee-time-off-balances',
    },
    {
        name: 'reporting.reports.timeOffRequests.title',
        description: 'reporting.reports.timeOffRequests.description',
        routerLink: 'time-off-requests',
    },
    {
        name: 'reporting.reports.turnoverProfile.title',
        description: 'reporting.reports.turnoverProfile.description',
        routerLink: 'turnover-profile',
        legacySlug: 'turnover',
        chartType: 'bar',
        showLegend: true,
        isStacked: false,
        isDateBased: true,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.missingEmployeeData.title',
        description: 'reporting.reports.missingEmployeeData.description',
        routerLink: 'insights/missing-data',
        legacySlug: '',
        chartType: 'bar',
        showLegend: true,
        isStacked: false,
        showCurrency: false,
    },
    {
        name: 'reporting.reports.assetReport.title',
        description: 'reporting.reports.assetReport.description',
        routerLink: 'asset-report',
    },
    {
        name: 'reporting.reports.timeTrackingReportForPayroll.title',
        description: 'reporting.reports.timeTrackingReportForPayroll.description',
        routerLink: 'time-tracking-payroll-report',
        requiredModule: Platform.modules.timeTracking,
    },
    {
        name: 'reporting.reports.compensationReport.title',
        description: 'reporting.reports.compensationReport.description',
        routerLink: 'compensation-report',
        showIfHasFeatureFlag: FeatureFlag.compensationReport,
    },
];
